const PageNotFoundText = [
  `Something happened that we didn’t anticipate.  `,
  `We are an education company, so we are always learning too…`,
  `Apologies for the error.`,
  `Don’t just take our word for it, after signing up, read Harvard Business Review on how acquiring new skills and knowledge is key to economic success in the 21st century Knowledge Economy.`,
  `HBR’s Article: Learning to Learn`,
  `If you are looking to advance your skill set and career:`,
  `Stop waiting and sign up!`,
  `If you are hoping improve your team or better connect with talent.`,
  `Visit our `,
  `Providers Page`,
  `or email us at: `,
  `info@academme.co`
]

export default PageNotFoundText



// WEBPACK FOOTER //
// src/text/page-not-found-text.js